import React from 'react';
import { Mail, Sparkles, Zap } from 'lucide-react';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Logo / Icon */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="absolute inset-0 bg-primary-500 blur-3xl opacity-20 rounded-full"></div>
            <div className="relative bg-white p-6 rounded-2xl shadow-xl">
              <Mail size={64} className="text-primary-600" />
            </div>
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
          Newsletter Automation
          <span className="block text-primary-600 mt-2">Platform</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-2xl mx-auto">
          AI-powered newsletter curation and automation for tech enthusiasts
        </p>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <Feature
            icon={<Mail className="text-blue-600" size={32} />}
            title="Email Collection"
            description="Automaticky sbírá emaily z vašich oblíbených tech newsletterů"
          />
          <Feature
            icon={<Sparkles className="text-purple-600" size={32} />}
            title="AI Analysis"
            description="Claude AI analyzuje a curuje nejzajímavější tech novinky"
          />
          <Feature
            icon={<Zap className="text-yellow-600" size={32} />}
            title="Auto Publishing"
            description="Automatické generování a publikování newsletterů na Beehiiv"
          />
        </div>

        {/* Tech Stack */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">Powered by</p>
          <div className="flex flex-wrap justify-center gap-6 text-gray-600">
            <TechBadge>Cloudflare Workers</TechBadge>
            <TechBadge>Claude AI</TechBadge>
            <TechBadge>React</TechBadge>
            <TechBadge>Beehiiv</TechBadge>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-sm text-gray-400">
          <p>© 2025 Newsletter Automation Platform</p>
        </div>
      </div>
    </div>
  );
}

function Feature({ icon, title, description }) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
      <div className="flex justify-center mb-4">{icon}</div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  );
}

function TechBadge({ children }) {
  return (
    <span className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm font-medium hover:bg-gray-200 transition-colors">
      {children}
    </span>
  );
}
